import { render, staticRenderFns } from "./dataSamples.vue.pug?vue&type=template&id=c74582a2&lang=pug&"
import script from "./dataSamples.vue.js?vue&type=script&lang=js&"
export * from "./dataSamples.vue.js?vue&type=script&lang=js&"
import style0 from "./dataSamples.vue.css?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports